import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import { List } from "linqts";

import WeeklyTransaction from "./WeeklyTransaction";
import { StatementTransaction, StatementInformationDetail } from "../../types/types";
import { useIsMaguireEnabled } from "../../utils/maguireHelper";
dayjs.extend(isoWeek);
export interface TransactionsProps {
  transactions: StatementTransaction[] | StatementInformationDetail[];
  isWeeklyStatement?: boolean;
}
const Transactions = (props: TransactionsProps) => {
  const isMaguireEnabled = useIsMaguireEnabled();
  if (props.transactions && props.transactions.length > 0) {
    // Check if the new system flow is enabled

    if (isMaguireEnabled) {
      if (props.isWeeklyStatement) {
        const allTransactions = props.transactions as StatementInformationDetail[];
        const groupedByTxnId = new List(allTransactions).GroupBy((t) => t.transactionId ?? "");
        const uniqueTransactions = Object.values(groupedByTxnId).map((group) => group[0]);
        const transactionsByWeek = new List<StatementInformationDetail>(uniqueTransactions).GroupBy(
          (t) => dayjs(t.transactionDate).week() ?? 0
        );
        return (
          <>
            {Object.keys(transactionsByWeek)
              .sort((a, b) => Number(a) - Number(b))
              .map((week, index) => (
                <WeeklyTransaction
                  key={index}
                  week={parseInt(week)}
                  transactions={transactionsByWeek[week]}
                  isWeeklyStatement={props.isWeeklyStatement}
                />
              ))}
          </>
        );
      } else {
        const arr = new List<StatementTransaction>(props.transactions as StatementTransaction[]);
        const transactionsByWeek = arr.GroupBy((t) => dayjs(t.entryDate).week() ?? 0);

        return (
          <>
            {Object.keys(transactionsByWeek)
              .sort((a, b) => Number(a) - Number(b))
              .map((week, index) => (
                <WeeklyTransaction
                  key={index}
                  week={parseInt(week)}
                  transactions={transactionsByWeek[week]}
                  isWeeklyStatement={props.isWeeklyStatement}
                />
              ))}
          </>
        );
      }
    } else {
      // Handle transactions as StatementTransaction[]
      const arr = new List<StatementTransaction>(props.transactions as StatementTransaction[]);
      const transactionsByWeek = arr.GroupBy((t) => dayjs(t.entryDate).week() ?? 0);
      return (
        <>
          {Object.keys(transactionsByWeek)
            .sort((a, b) => Number(a) - Number(b))
            .map((week, index) => (
              <WeeklyTransaction key={index} week={parseInt(week)} transactions={transactionsByWeek[week]} />
            ))}
        </>
      );
    }
  } else {
    return <div></div>;
  }
};
export default Transactions;
